import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { HistorialCorte } from '../../models/historial-corte';
import { generalService } from '../../services/general.service';
import * as moment from 'moment';
import { Usuario } from '../../models/usuario';
import { DataService } from '../../utils/data.service';
import { MatDialog } from '@angular/material';
import { modalComponent } from '../../utils/modal/modal.component';

@Component({
  selector: 'app-historico-corte-caja',
  templateUrl: './historico-corte-caja.component.html',
  styleUrls: ['./historico-corte-caja.component.scss'],
  providers: [generalService]
})
export class HistoricoCorteCajaComponent implements OnInit {

  // Configuracion del daterangepicker
  public locale: {
    format: 'DD-MM-YYYY', 
    separator: ' - ',
    applyLabel: 'Aceptar',
    firstDay: 1
  };
  public ranges: any = {
    'Hoy': [moment(), moment()],
    'Mes actual': [moment().startOf('month'), moment().endOf('month')],
    'Ultimos 2 meses': [moment().subtract(2, 'month').startOf('month'), moment(), moment()]
  };
  public dateRange: any = {
    startDate: moment().startOf('month'),
    endDate: moment()
  };
  
  private corteCajaService = 'corteCaja/';
  // Modal messages
  private readonly CONFIRM_DELETE_MSG = '¿Deseas eliminar el corte de caja?';

  public historicos: HistorialCorte[] = [];
  public actualizarGrid: Subject<any[]> = new Subject();
  public idRowSelector = 'idHistorialCorte';
  public columnasAMostrar = ['accion',
                             'numeroCorte',
                             'fechaCorte',
                             'usuario',
                             'tipoCorte',
                             'montoMetodoEfectivo',
                             'montoMetodoOtros',
                             'retiro',
                             'ingresoEfectivo',
                             'ingresoVoucher',
                             'totalIngresos',
                             'fondoCaja',
                             'diferencia',
                             'tipoDiferencia',
                             'accionDiferencia', 
                            'rangoVentas'];
  public nombreColumnas = {accion: 'Acción',
                           numeroCorte: 'Núm. de Corte',
                           fechaCorte: 'Fecha de Corte',
                           usuario: 'Usuario',
                           tipoCorte: 'Tipo de Corte',
                           montoMetodoEfectivo: 'Métodos de Pago Efectivo $',
                           montoMetodoOtros: 'Métodos de Pago Otros $',
                           retiro: 'Retiros $',
                           ingresoEfectivo: 'Ingresos Efectivo $',
                           ingresoVoucher: 'Ingresos Voucher $',
                           totalIngresos: 'Total Ingresos $',
                           fondoCaja: 'Fondo de Caja $',
                           diferencia: 'Diferencia $',
                           tipoDiferencia: 'Tipo de Diferencia',
                           accionDiferencia: 'Acción Diferencia', 
                          rangoVentas: 'Última Venta del Corte'};

  @Output()
  public detalleHistoricoEvent: EventEmitter<number> = new EventEmitter();
  constructor(private _generalService: generalService,public dataService: DataService,
    public dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.cargarPantalla();
  }

  cargarPantalla(){
    const rangoInicio = this.dateRange.startDate.format('YYYY-MM-DD');
    const rangoFinal = this.dateRange.endDate.format('YYYY-MM-DD');
    this.consultarHistoricoCorte(rangoInicio, rangoFinal);
  }

  consultarHistoricoCorte(rangoInicio, rangoFinal) {
    const usuario: Usuario = JSON.parse(sessionStorage.getItem('user'));
    const organizationId = usuario.ORGANIZATION_ID;
    
    this._generalService.metodoCall(this.corteCajaService + `/consultarHistoricoCorte?organizationId=${organizationId}&&rangoInicio=${rangoInicio}&&rangoFinal=${rangoFinal}`, true)
        .subscribe((historicos) => {
          this.actualizarGrid.next(historicos);
        }, (error) => {
        });
  }

  consultarDetalles(idHistorialCorte: number) {
    this.detalleHistoricoEvent.emit(idHistorialCorte);
  }

  cambiarFechas(rangos) {
    const rangoInicio = rangos.startDate.format('YYYY-MM-DD');
    const rangoFinal = rangos.endDate.format('YYYY-MM-DD');
    this.consultarHistoricoCorte(rangoInicio, rangoFinal); 
  }

 

  eliminarHistorico(idHistorialCorte: number) {
    this.dataService.modal = 'confirm';
    this.dataService.mensaje = this.CONFIRM_DELETE_MSG;
  
    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogRef = dialogModal;

   
  
    dialogModal.afterClosed().subscribe(result => {
      if (this.dataService.guardado) {
       this.deleterow(idHistorialCorte);
      
      }
    });
}
  
deleterow(id_HistorialCorte: number) {
  const idHistorialCorte = id_HistorialCorte
    this._generalService.metodoCall(this.corteCajaService + `/deleteCorteCaja?idHistorialCorte=${idHistorialCorte}`, true)
        .subscribe((historicos) => {
          this.cargarPantalla();

          setTimeout(() => {
            this._generalService.toastCall("El registro se dio de baja exitosamente");
          }, 500); 

        }, (error) => {
    });
        
}

}



// WEBPACK FOOTER //
// ./src/app/corte-caja/historico-corte-caja/historico-corte-caja.component.ts